// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"494":"174ff782","856":"3134178b"}[chunkId] + ".js";
};